import {useEffect} from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import iotDeviceSettingsService from '../../../services/iotDevice/iotDeviceSettingsService';
import yapConnectionService from '../../../services/yap/yapConnectionService';
import {makeSelectIotDeviceFullData} from '../../../state/selectors/consumer';
import {makeSelectIsScpCheckInProgress, makeSelectIsStartAutoSync} from '../../../state/selectors/global';
import {makeSelectIsDeviceReady, selectIsFirmwareInProgress} from '../../../state/selectors/iotDevice';
import {
    makeSelectIsYapFirmwareInProgress,
    makeSelectIsYapHolderInfoReceived,
} from '../../../state/selectors/yapEncrypted';

const mapStateToProps = createStructuredSelector({
    iotProduct: makeSelectIotDeviceFullData(),
    isDeviceReady: makeSelectIsDeviceReady(),
    isYapHolderInfoReceived: makeSelectIsYapHolderInfoReceived(),
    isStartAutoSync: makeSelectIsStartAutoSync(),
    isScpCheckInProgress: makeSelectIsScpCheckInProgress(),
    isFirmwareInProgress: selectIsFirmwareInProgress,
    isYapFirmwareInProgress: makeSelectIsYapFirmwareInProgress(),
});

const DeviceHolderConnectionChecker = ({
    iotProduct,
    isDeviceReady,
    isYapHolderInfoReceived,
    isStartAutoSync,
    isScpCheckInProgress,
    isFirmwareInProgress,
    isYapFirmwareInProgress,
}) => {
    const {device, holder} = iotProduct || {};
    const {isHolderConnected} = device || {};
    const {deviceSerialNumber: holderSerialNumber} = holder || {};
    const isHolderInSBLMode = iotDeviceSettingsService.isHolderInSBLMode(iotProduct);
    const isStartHolderSync =
        holderSerialNumber &&
        isDeviceReady &&
        isHolderConnected &&
        !isYapHolderInfoReceived &&
        isStartAutoSync &&
        !isScpCheckInProgress &&
        !isHolderInSBLMode &&
        !isFirmwareInProgress &&
        !isYapFirmwareInProgress;

    useEffect(() => {
        if (isStartHolderSync) {
            yapConnectionService.initSynchronizeFlow(true);
        }
    }, [isStartHolderSync]);

    return null;
};

export default connect(mapStateToProps)(DeviceHolderConnectionChecker);
